import { createBrowserHistory } from 'history';

export const browserHistory = createBrowserHistory();


// WEBPACK FOOTER //
// ./src/utilities/history.ts